<template>
  <b-sidebar
    id="add-new-group-sidebar"
    :visible="isAddNewCalendarSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetData"
    @change="(val) => $emit('update:is-add-new-calendar-sidebar-active', val)"
  >

    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Add New Calendar')}}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner
            :animation-duration="1000"
            :size="100"
            :color="'#0e96b1'"
        />
      </div>


      <b-col>
        <b-row>

          <b-col class="mt-3">

            <!-- Name ar -->
            <b-form-group :label="$t('Name')" label-for="name">
              <b-form-input
                  id="ar_name"
                  v-model="calendarData.name"
                  autofocus
                  :state="errors && ('name' in errors) ? false : null"
                  trim
                  autocomplete="off"
                  :placeholder="$t('Name')"
              />

              <b-form-invalid-feedback :state="errors && ('name' in errors) ? false: null">
                {{ errors && ('name' in errors) ? errors.name[0] : null }}
              </b-form-invalid-feedback>

            </b-form-group>

            <!-- ics file -->
            <b-form-group :label="$t('Calendar File')" label-for="file">
              <b-form-file
                  ref="refInputEl"
                  accept=".ics"
                  id="file"
                  autofocus
                  @input="inputImageRenderer"
                  :state="errors && ('data' in errors) ? false : null"
                  trim
                  :placeholder="$t('ics file')"
              />

              <b-form-invalid-feedback :state="errors && ('data' in errors) ? false: null">
                {{ errors && ('data' in errors) ? errors.data[0] : null }}
              </b-form-invalid-feedback>

            </b-form-group>

            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mr-2"
                  @click="onSubmit"
                  type="submit">
                {{ $t('Save')}}
              </b-button>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="button"
                  variant="outline-secondary"
                  @click="resetData">
                {{ $t('Reset') }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-col>

    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
  BFormTextarea, BFormFile, BCol, BRow
} from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import useGroupEdit from '@/views/modules/group/groups-edit/useGroupEdit'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'

export default {
  components: {
    BSidebar,
    BForm,BCol,BRow,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    OrbitSpinner,

    flatPickr,

  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewCalendarSidebarActive',
    event: 'update:is-add-new-calendar-sidebar-active',
  },
  props: {
    isAddNewCalendarSidebarActive: {
      type: Boolean,
      required: true,
    },

  },
  setup(props, { emit, root, refs }) {

    const blankData = {
      name: '',
      data: '',
    }

    const errors = ref(null)

    const requestStatus = ref(false)

    const { toaster } = useGroupEdit(root)

    const calendarData = ref(JSON.parse(JSON.stringify(blankData)))

    const resetData = () => {
      calendarData.value = JSON.parse(JSON.stringify(blankData))
    }

    const refInputEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => {
      calendarData.value.data = base64.split(',')[1]
    })


    const onSubmit = () => {

      requestStatus.value = true
      errors.value = null

      store.dispatch('app-calendar/addCalendar', calendarData.value)
        .then(() => {
          requestStatus.value = false
          emit('refetch-data')
          emit('update:is-add-new-calendar-sidebar-active', false)
          toaster('Calendar Added Successfully')
        }).catch(res => {
          requestStatus.value = false
          if (res.response.status === 422) {
            errors.value = res.response.data}
           console.log(res.response.data)

          }
      )
    }


    return {
      calendarData,
      onSubmit,
      resetData,
      requestStatus,
      errors,
      inputImageRenderer,
      refInputEl
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
#add-new-type-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
